import type { FC } from 'react';

import { SummaryHero } from './SummaryHero';

/** Before any summary exists. The Generate action sits in the panel footer. */
export const StartState: FC = () => (
  <div data-testid="renewal-summary-start">
    <SummaryHero title="Summarise this renewal">
      Create a client-ready summary of what&apos;s changed between the expiring contract and this renewal, based on the
      comparison.
    </SummaryHero>
  </div>
);
